<app-header></app-header>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple"></ngx-spinner>
<div class="row no-mar-lr mar-tb-20">
  <div class="col-md-5">
    <span class="dta_title">{{'Package Data Availability' | translate}}</span>
  </div>
  <div class="col-md-7 pad-top-10 text-right">
    <a href="#/poFCMonthly" class="has-link">{{'Monthly View' | translate}}</a> |
    <a href="#/poFCJun" class="has-link">{{'Jun View' | translate}}</a> |
    <a href="#/poFCDaily" class="has-link">{{'Daily View' | translate}}</a> |
    <a href="#/poSummary" class="has-link">{{'Package Data Availability' | translate}}</a> |
    <a href="#/poDashboard" class="has-link">Back&nbsp;<i class="fa fa-reply" aria-hidden="true"></i></a>
  </div>
</div>
<div class="container-fluid">
    <div class="offset-md-2 col-md-6 mar-top-50">
        <!-- <input  placeholder="{{'filter all columns' | translate}}"
        [(ngModel)]="srchValue"
        class="form-control"
        />
        <span class="input-group-btn">
          <button class="btn btn-light" type="button"
              (click)="onChangeTable(config)">
              {{'Search' | translate}}
          </button>
      </span> -->

      <div class="row">
        <div class="col-md-6 mx-auto">
            <div class="input-group custom-search-form" >
                <input type="text" class="form-control" [(ngModel)]="srchValue"
                    class="form-control" placeholder="{{'filter all columns' | translate}}">
                <span class="input-group-btn">
                    <button class="btn btn-light" type="button"
                        (click)="onChangeTable(config)">
                        {{'Search' | translate}}
                    </button>
                </span>
            </div>
        </div>
    </div>
    </div>
  <div class="row no-mar-lr mat-btm-40">
    <div class="col-md-10">
          <!-- <pagination *ngIf="config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page" [totalItems]="length" [itemsPerPage]="itemsPerPage"
            [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)" (numPages)="numPages = $event">
          </pagination>
      <ng-table [config]="config" (tableChanged)="onChangeTable(config)" [rows]="rows" [columns]="columns"></ng-table> -->

   

      <pagination *ngIf="config.paging" class="pad-top-10" [(ngModel)]="page" [totalItems]="length" [itemsPerPage]="itemsPerPage"
            [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)" (numPages)="numPages = $event">
          </pagination>
      <div class="example-container mat-elevation-z8">
      
        <mat-table [dataSource]="dataSource" matSort>
      
          
          <ng-container matColumnDef="supplierCode">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Supplier Code </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.supplierCode}} </mat-cell>
          </ng-container>
      
          
          <ng-container matColumnDef="totalPkgIdCount">
            <mat-header-cell *matHeaderCellDef mat-sort-header> totalPkgIdCount</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.totalPkgIdCount}} </mat-cell>
          </ng-container>
      
        
          <ng-container matColumnDef="availPkgIdCount">
            <mat-header-cell *matHeaderCellDef mat-sort-header> availPkgIdCount </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.availPkgIdCount}} </mat-cell>
          </ng-container>
      
       
          <ng-container matColumnDef="availPkgIdPer">
            <mat-header-cell *matHeaderCellDef mat-sort-header> availPkgIdPer </mat-header-cell>
            <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.availPkgIdPer}} </mat-cell>
          </ng-container>
      
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;">
          </mat-row>
        </mat-table>
      
       
      </div>
      
      <div class="noRecords" *ngIf="rows.length == 0">{{'No Records Found' | translate}}!</div>
    </div>
  </div>
</div>